import { number, string } from 'prop-types'

export const svgPropTypes = {
  colour: string,
  size: number,
}

export default svgPropTypes
